import axios from "axios";
import { headers, reqErrorHandler, reqHandler, resErrorHandler, resHandler } from "./common/axiosUtil";
import { PROPERTIES } from '../../enums/config';

const xeroxApi = axios.create({
    baseURL: PROPERTIES.ENV.BASE_URL + PROPERTIES.ENV.API_PATH, headers
});

xeroxApi.interceptors.request.use(reqHandler, reqErrorHandler);
xeroxApi.interceptors.response.use(resHandler, resErrorHandler);

export default xeroxApi;
